import React, { Children, forwardRef, Fragment } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import List from '@polestar/component-warehouse-react/components/list/List';
import Divider from '@polestar/component-warehouse-react/components/divider/Divider';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Spacer from '@polestar/component-warehouse-react/components/spacer/Spacer';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import { formatPath } from './SummaryList.helpers';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import { useSSRSafeId } from '@polestar/component-warehouse-react/contexts/ssr';
export var SummaryListVariants;
(function (SummaryListVariants) {
    SummaryListVariants["list"] = "list";
    SummaryListVariants["numbered"] = "numbered";
})(SummaryListVariants || (SummaryListVariants = {}));
export var SummaryListNumberColors;
(function (SummaryListNumberColors) {
    SummaryListNumberColors["default"] = "default";
    SummaryListNumberColors["accent"] = "accent";
})(SummaryListNumberColors || (SummaryListNumberColors = {}));
const SummaryList = forwardRef(({ children, title, variant = SummaryListVariants.numbered, size = Sizes.large, numberSize = Sizes.large, numberColor = SummaryListNumberColors.default, ...props }, ref) => {
    const memoizedId = useSSRSafeId('summary-list', props.id);
    const memoizedLabelId = `${memoizedId}-label`;
    return (React.createElement(Fragment, null,
        title && (React.createElement(TitleContainer, { id: memoizedLabelId, size: size }, title)),
        React.createElement(StyledList, { id: memoizedId, ...aria({ labelledby: memoizedLabelId ? memoizedLabelId : undefined }), ...props, ref: ref, as: 'ul', hasTitle: !!title, size: size, separator: React.createElement(Divider, { as: "li", ...aria({ hidden: true }), spacing: size === Sizes.medium ? Spacings.xLarge : Spacings.xxLarge }) }, Children.map(children, (child, index) => {
            return (React.createElement(Fragment, null,
                variant === SummaryListVariants.numbered && (React.createElement(Fragment, null,
                    React.createElement(IndexNumber, { numberSize: numberSize, size: size, numberColor: numberColor }, formatPath(index)),
                    size === Sizes.medium && numberSize === Sizes.large && (React.createElement(Spacer, { spacing: Spacings.xSmall })))),
                child));
        }))));
});
SummaryList.displayName = 'SummaryList';
export default SummaryList;
const StyledList = styled(List)(({ hasTitle, size }) => css(css `
        width: 100%;
      `, hasTitle &&
    size === Sizes.large &&
    css `
          padding-block-start: ${Spacings.medium};
        `));
StyledList.displayName = `StyledList`;
const TitleContainer = styled.div(({ size }) => css(css `
      width: 100%;
    `, size === Sizes.large &&
    css `
        ${responsiveStyles({
        paddingBlockEnd: {
            mobile: Spacings.medium,
            desktop: Spacings.large,
        },
    })};
      `, size === Sizes.medium &&
    css `
        padding-block-end: ${Spacings.medium};
      `));
const IndexNumber = styled.div(({ theme, size, numberSize, numberColor }) => css(css `
      display: flex;
      flex-grow: 1;
      width: 100%;
      color: ${theme.summaryList.indexColor};
    `, size === Sizes.medium && numberSize === Sizes.medium
    ? css `
          font-size: ${FontSizes.body};
          line-height: ${LineHeights.small};
        `
    : css `
          font-size: ${FontSizes.large};
          line-height: ${LineHeights.large};
        `, numberSize === Sizes.large &&
    numberColor === SummaryListNumberColors.accent &&
    css `
        color: ${theme.summaryList.indexColorAccent};
      `));
